// Auto-generated Scaffold-ETH compatible exports
// This file is generated by sync-to-published.js

export type GenericContract = {
  address: string
  abi: any[]
  inheritedFunctions?: Record<string, any>
}

export type GenericContractsDeclaration = {
  [chainId: number]: {
    [contractName: string]: GenericContract
  }
}

// Type-safe chain IDs and contract names
export type SupportedChainId = 57054 | 59141
export type ContractName = "ActivePool" | "BorrowerOperations" | "CollSurplusPool" | "DebtCapLens" | "DebtCapManager" | "DefaultPool" | "HintHelpers" | "SortedVaults" | "StabilityPool" | "VaultManager" | "VaultedgeController" | "VeUSDToken"

/**
 * VaultEdge contracts in Scaffold-ETH format
 * Use this in Scaffold-ETH projects for seamless integration
 * 
 * @example
 * import { deployedContracts } from '@vaultedge/v1-core/scaffold-eth'
 * 
 * // Use with Scaffold-ETH hooks
 * const { data } = useScaffoldReadContract({
 *   contractName: "VaultedgeController",
 *   functionName: "someFunction"
 * })
 */
export const deployedContracts = {
  "57054": {
    "VaultedgeController": {
      "address": "0x83e767B100B7c4e22871a58B3a6E8eDd5359496E",
      "abi": [
        {
          "inputs": [],
          "name": "AbsorptionWeightsNotEqualToOne",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "AddressZero",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "CCRMustBeGreaterThanMCR",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "CCRTooHigh",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "CallerMustBeBorrowerOperations",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "CollateralAlreadyActive",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "CollateralAlreadyExists",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "CollateralDoesNotExist",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "CollateralListNotSorted",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "CollateralNotActive",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ControllerAlreadyInitialized",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "FeeCurveNotInitialized",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "GasCompensationTooHigh",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "GasCompensationZero",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InterestTimeWindowTooShort",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidInputLength",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidNewMax",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidSplitOrRatio",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "MCRMustBeLessThanCCR",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "MCRTooHigh",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "MCRTooLow",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "MaxFeeBelowFloor",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "MaxFeeTooHigh",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "MaxSystemCollsReached",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "MinNetDebtZero",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "MinuteDecayFactorTooHigh",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "MinuteDecayFactorZero",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NotOperationalControllerTimelock",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NotSafetyOperationsTimelock",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "RedemptionFeeFloorTooHigh",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "TimelockAddressZero",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "UnreasonableBorrowingFeeFloor",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "UnreasonableInterestRate",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "VaultManagerAlreadySet",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "WithdrawDepositCollateralOverlap",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newBoostMinuteDecayFactor",
              "type": "uint256"
            }
          ],
          "name": "BoostMinuteDecayFactorChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newBorrowingFeeFloor",
              "type": "uint256"
            }
          ],
          "name": "BorrowingFeeFloorChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "oldCCR",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "newCCR",
              "type": "uint256"
            }
          ],
          "name": "CCRChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_newClaimAddress",
              "type": "address"
            }
          ],
          "name": "ClaimAddressChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "CollateralAdded",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "CollateralDeprecated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "CollateralUndeprecated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "_newDefaultRouter",
              "type": "address"
            }
          ],
          "name": "DefaultRouterChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "_newFeeCurve",
              "type": "address"
            }
          ],
          "name": "FeeCurveChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newGlobalBoostMultiplier",
              "type": "uint256"
            }
          ],
          "name": "GlobalBoostMultiplierChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "bool",
              "name": "_canMint",
              "type": "bool"
            }
          ],
          "name": "GlobalVEUSDMintOn",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint8",
              "name": "version",
              "type": "uint8"
            }
          ],
          "name": "Initialized",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newInterestRate",
              "type": "uint256"
            }
          ],
          "name": "InterestRateChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newInterestTimeWindow",
              "type": "uint256"
            }
          ],
          "name": "InterestTimeWindowChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "bool",
              "name": "oldValue",
              "type": "bool"
            },
            {
              "indexed": false,
              "internalType": "bool",
              "name": "newValue",
              "type": "bool"
            }
          ],
          "name": "LeverUpEnabledChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "oldMCR",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "newMCR",
              "type": "uint256"
            }
          ],
          "name": "MCRChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "oldMaxFee",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "newMaxFee",
              "type": "uint256"
            }
          ],
          "name": "MaxBorrowingFeeChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newMaxCollsInVault",
              "type": "uint256"
            }
          ],
          "name": "MaxCollsInVaultChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newMaxSystemColls",
              "type": "uint256"
            }
          ],
          "name": "MaxSystemCollsChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "oldMinNetDebt",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "newMinNetDebt",
              "type": "uint256"
            }
          ],
          "name": "MinNetDebtChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "oldDecayFactor",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "newDecayFactor",
              "type": "uint256"
            }
          ],
          "name": "MinuteDecayFactorChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "oldOperationsManager",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "newOperationsManager",
              "type": "address"
            }
          ],
          "name": "OperationsManagerTransferred",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "_newOracle",
              "type": "address"
            }
          ],
          "name": "OracleChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "previousOwner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "OwnershipTransferred",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newRecoveryRatio",
              "type": "uint256"
            }
          ],
          "name": "RecoveryRatioChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newSplit",
              "type": "uint256"
            }
          ],
          "name": "RedemptionBorrowerFeeSplitChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "oldFeeFloor",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "newFeeFloor",
              "type": "uint256"
            }
          ],
          "name": "RedemptionFeeFloorChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "bool",
              "name": "_enabled",
              "type": "bool"
            }
          ],
          "name": "RedemptionsEnabledUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newSafetyRatio",
              "type": "uint256"
            }
          ],
          "name": "SafetyRatioChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "oldStabilityPoolManager",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "newStabilityPoolManagerT",
              "type": "address"
            }
          ],
          "name": "StabilityPoolManagerTransferred",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_contractAddress",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "bool",
              "name": "_isWhitelisted",
              "type": "bool"
            }
          ],
          "name": "UpdateVeVaultedgeCallers",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_newFeeRecipient",
              "type": "address"
            }
          ],
          "name": "VEUSDFeeRecipientChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "oldVaultManager",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "newVaultManager",
              "type": "address"
            }
          ],
          "name": "VaultManagerAddressChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_newTreasury",
              "type": "address"
            }
          ],
          "name": "VaultedgeFinanceTreasuryChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newSplit",
              "type": "uint256"
            }
          ],
          "name": "VaultedgeFinanceTreasurySplitChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "oldCompensation",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "newCompensation",
              "type": "uint256"
            }
          ],
          "name": "VeUSDGasCompensationChanged",
          "type": "event"
        },
        {
          "inputs": [],
          "name": "CCR",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "MCR",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "VEUSDFeeRecipient",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "name": "absorptionColls",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "name": "absorptionWeights",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_safetyRatio",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_recoveryRatio",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_oracle",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_decimals",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_feeCurve",
              "type": "address"
            },
            {
              "internalType": "bool",
              "name": "_isEdgeStrategy",
              "type": "bool"
            },
            {
              "internalType": "address",
              "name": "_routerAddress",
              "type": "address"
            }
          ],
          "name": "addCollateral",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "borrowingFeeFloor",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_newBoostMinuteDecayFactor",
              "type": "uint256"
            }
          ],
          "name": "changeBoostMinuteDecayFactor",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_newClaimAddress",
              "type": "address"
            }
          ],
          "name": "changeClaimAddress",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_feeCurve",
              "type": "address"
            }
          ],
          "name": "changeFeeCurve",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_newGlobalBoostMultiplier",
              "type": "uint256"
            }
          ],
          "name": "changeGlobalBoostMultiplier",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_newInterestTimeWindow",
              "type": "uint256"
            }
          ],
          "name": "changeInterestTimeWindow",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_oracle",
              "type": "address"
            }
          ],
          "name": "changeOracle",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_newSafetyRatio",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_newRecoveryRatio",
              "type": "uint256"
            }
          ],
          "name": "changeRatios",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_newSplit",
              "type": "uint256"
            }
          ],
          "name": "changeRedemptionBorrowerFeeSplit",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_newFeeRecipient",
              "type": "address"
            }
          ],
          "name": "changeVEUSDFeeRecipient",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_newTreasury",
              "type": "address"
            }
          ],
          "name": "changeVaultedgeFinanceTreasury",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_newSplit",
              "type": "uint256"
            }
          ],
          "name": "changeVaultedgeFinanceTreasurySplit",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_depositColls",
              "type": "address[]"
            },
            {
              "internalType": "address[]",
              "name": "_withdrawColls",
              "type": "address[]"
            }
          ],
          "name": "checkCollateralListDouble",
          "outputs": [],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_colls",
              "type": "address[]"
            },
            {
              "internalType": "bool",
              "name": "_deposit",
              "type": "bool"
            }
          ],
          "name": "checkCollateralListSingle",
          "outputs": [],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "name": "collateralParams",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "safetyRatio",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "recoveryRatio",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "oracle",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "decimals",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "feeCurve",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "index",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "defaultRouter",
              "type": "address"
            },
            {
              "internalType": "bool",
              "name": "active",
              "type": "bool"
            },
            {
              "internalType": "bool",
              "name": "isEdgeStrategy",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "deprecateAllCollateral",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "deprecateCollateral",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getAbsorptionCollParams",
          "outputs": [
            {
              "internalType": "address[]",
              "name": "",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getBorrowingFeeFloor",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getClaimAddress",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getDecimals",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getDefaultRouterAddress",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getEntireSystemColl",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getEntireSystemDebt",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getFeeCurve",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getFeeSplitInformation",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getIndex",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_colls",
              "type": "address[]"
            }
          ],
          "name": "getIndices",
          "outputs": [
            {
              "internalType": "uint256[]",
              "name": "indices",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_colls",
              "type": "address[]"
            }
          ],
          "name": "getInterestRates",
          "outputs": [
            {
              "internalType": "uint256[]",
              "name": "rates",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getIsActive",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getMaxCollsInVault",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getOracle",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getPrice",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getRecoveryRatio",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getRedemptionBorrowerFeeSplit",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getSafetyRatio",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_tokensIn",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amountsIn",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_leverages",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256",
              "name": "_entireSystemCollVC",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_VCin",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_VCout",
              "type": "uint256"
            }
          ],
          "name": "getTotalVariableDepositFeeAndUpdate",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "VEUSDFee",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "boostFactor",
              "type": "uint256"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getVEUSDFeeRecipient",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getValidCollateral",
          "outputs": [
            {
              "internalType": "address[]",
              "name": "",
              "type": "address[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "getValueRVC",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "getValueUSD",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "getValueVC",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "getValuesRVC",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "RVCValueTotal",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "getValuesUSD",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "USDValue",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "getValuesVC",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "VCValue",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "getValuesVCAndRVC",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "VCValueTotal",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "RVCValueTotal",
              "type": "uint256"
            },
            {
              "internalType": "uint256[]",
              "name": "VCPerCollateral",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "getValuesVCAndRVCAndWeights",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "VCValueTotal",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "RVCValueTotal",
              "type": "uint256"
            },
            {
              "internalType": "uint256[]",
              "name": "VCPerCollateral",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256[]",
              "name": "VCWeightsPerCollateral",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "getValuesVCIndividual",
          "outputs": [
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_collateralAmount",
              "type": "uint256"
            }
          ],
          "name": "getVariableDepositCollateralFee",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_collateralVCInput",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_collateralVCSystemBalance",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_totalVCBalancePre",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_totalVCBalancePost",
              "type": "uint256"
            }
          ],
          "name": "getVariableDepositFee",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getVaultedgeFinanceTreasury",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getVaultedgeFinanceTreasurySplit",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "activePool",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "defaultPool",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "stabilityPool",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "collSurplusPool",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "borrowerOperations",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "veusdToken",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "VEUSDFeeRecipient",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "vaultedgeFinanceTreasury",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "sortedVaults",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "vaultManagerRedemptions",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "vaultManager",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "claimAddress",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "operationsManager",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "stabilityPoolManager",
                  "type": "address"
                }
              ],
              "internalType": "struct IVaultedgeControllerInitializer.ControllerAddresses",
              "name": "_addresses",
              "type": "tuple"
            }
          ],
          "name": "initialize",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "name": "interestRates",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "isEdgeStrategy",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            }
          ],
          "name": "isEdgeStrategyMany",
          "outputs": [
            {
              "internalType": "bool[]",
              "name": "isEdgeStrategy",
              "type": "bool[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "leverUpEnabled",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "maxBorrowingFee",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "maxCollsInVault",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "maxSystemColls",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "minNetDebt",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "minuteDecayFactor",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "operationsManager",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "owner",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "redemptionBorrowerFeeSplit",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "redemptionFeeFloor",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "renounceOwnership",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_newBorrowingFeeFloor",
              "type": "uint256"
            }
          ],
          "name": "setBorrowingFeeFloor",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_CCR",
              "type": "uint256"
            }
          ],
          "name": "setCCR",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_router",
              "type": "address"
            }
          ],
          "name": "setDefaultRouter",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_colls",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_newRates",
              "type": "uint256[]"
            }
          ],
          "name": "setInterestRates",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bool",
              "name": "_enabled",
              "type": "bool"
            }
          ],
          "name": "setLeverUp",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_MCR",
              "type": "uint256"
            }
          ],
          "name": "setMCR",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_maxBorrowingFee",
              "type": "uint256"
            }
          ],
          "name": "setMaxBorrowingFee",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_minNetDebt",
              "type": "uint256"
            }
          ],
          "name": "setMinNetDebt",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_minuteDecayFactor",
              "type": "uint256"
            }
          ],
          "name": "setMinuteDecayFactor",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_redemptionFeeFloor",
              "type": "uint256"
            }
          ],
          "name": "setRedemptionFeeFloor",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_vm",
              "type": "address"
            }
          ],
          "name": "setVaultManager",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_veUSDGasCompensation",
              "type": "uint256"
            }
          ],
          "name": "setVeUSDGasCompensation",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "stabilityPoolManager",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_rewarder",
              "type": "address"
            },
            {
              "internalType": "bool",
              "name": "_isRewarder",
              "type": "bool"
            }
          ],
          "name": "toggleVaultManagerRewarder",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "transferOwnership",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_newOperationsManager",
              "type": "address"
            }
          ],
          "name": "transferoperationsManager",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_newSafetyOperations",
              "type": "address"
            }
          ],
          "name": "transferstabilityPoolManager",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "unDeprecateCollateral",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_colls",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_weights",
              "type": "uint256[]"
            }
          ],
          "name": "updateAbsorptionColls",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_newMax",
              "type": "uint256"
            }
          ],
          "name": "updateMaxCollsInVault",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_newMax",
              "type": "uint256"
            }
          ],
          "name": "updateMaxSystemColls",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bool",
              "name": "_enabled",
              "type": "bool"
            }
          ],
          "name": "updateRedemptionsEnabled",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "name": "validCollateral",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "vaultedgeFinanceTreasury",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "vaultedgeFinanceTreasurySplit",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "veUSDGasCompensation",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "veusdToken",
          "outputs": [
            {
              "internalType": "contract IveUSDToken_0_6",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        }
      ],
      "inheritedFunctions": {}
    },
    "VeUSDToken": {
      "address": "0xed6E002E6DB4A0E083c97aEcCC25201a3e83dA43",
      "abi": [
        {
          "inputs": [],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "inputs": [],
          "name": "AddressZero",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "bridge",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "effectiveTime",
              "type": "uint256"
            }
          ],
          "name": "BridgeMintLimitProposalNotReady",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            },
            {
              "internalType": "bytes32",
              "name": "alreadyHasRole",
              "type": "bytes32"
            }
          ],
          "name": "DuplicateBridgeAndProtocolRole",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "IXERC20_LimitsTooHigh",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "IXERC20_NotFactory",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "IXERC20_NotHighEnoughLimits",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InitializerAlreadySet",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InitializerNotSet",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "InvalidBurnerRole",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidEnableMintingRole",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "InvalidMinterRole",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidPauseMintingRole",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "LockboxIsDisabled",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "MintingAlreadySet",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "bridge",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "newMintLimit",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "currentMintLimit",
              "type": "uint256"
            }
          ],
          "name": "MustProposeMintingLimitIncrease",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NoValidUpdatesProvided",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "NotAdminOrBridgeRiskManagerRole",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NotAuthorizedInitializer",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "minRatio",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "currentRatio",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "protocolSupply",
              "type": "uint256"
            },
            {
              "internalType": "int256",
              "name": "bridgeSupply",
              "type": "int256"
            }
          ],
          "name": "SupplyRatioBelowLimit",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "ratio",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "minRatio",
              "type": "uint256"
            }
          ],
          "name": "SupplyRatioTooLow",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "spender",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "value",
              "type": "uint256"
            }
          ],
          "name": "Approval",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_oldBorrowerOperationsAddress",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "_newBorrowerOperationsAddress",
              "type": "address"
            }
          ],
          "name": "BorrowerOperationsAddressChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "bridge",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "remainingBurnLimit",
              "type": "uint256"
            }
          ],
          "name": "BridgeBurn",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_burningLimit",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "_bridge",
              "type": "address"
            }
          ],
          "name": "BridgeBurnLimitChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_mintingLimit",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_burningLimit",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "_bridge",
              "type": "address"
            }
          ],
          "name": "BridgeLimitsSet",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "bridge",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "recipient",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "remainingMintLimit",
              "type": "uint256"
            }
          ],
          "name": "BridgeMint",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_mintingLimit",
              "type": "uint256"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "_bridge",
              "type": "address"
            }
          ],
          "name": "BridgeMintLimitChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "bridge",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "newMintLimit",
              "type": "uint256"
            }
          ],
          "name": "BridgeMintLimitIncreaseExecuted",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "bridge",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "newMintLimit",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "executionTime",
              "type": "uint256"
            }
          ],
          "name": "BridgeMintLimitIncreaseProposed",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "bridge",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "currentMintLimit",
              "type": "uint256"
            }
          ],
          "name": "BridgeMintLimitIncreaseRevoked",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "BridgingPaused",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "BridgingUnpaused",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [],
          "name": "EIP712DomainChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint8",
              "name": "version",
              "type": "uint8"
            }
          ],
          "name": "Initialized",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "lockbox",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            }
          ],
          "name": "LockBoxBurn",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "lockbox",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "recipient",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            }
          ],
          "name": "LockBoxMint",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [],
          "name": "LockboxDisabled",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_lockbox",
              "type": "address"
            }
          ],
          "name": "LockboxSet",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "oldRatio",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "newRatio",
              "type": "uint256"
            }
          ],
          "name": "MinProtocolSupplyToBridgeSupplyRatioUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "bytes32",
              "name": "role",
              "type": "bytes32"
            },
            {
              "indexed": true,
              "internalType": "bytes32",
              "name": "previousAdminRole",
              "type": "bytes32"
            },
            {
              "indexed": true,
              "internalType": "bytes32",
              "name": "newAdminRole",
              "type": "bytes32"
            }
          ],
          "name": "RoleAdminChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "bytes32",
              "name": "role",
              "type": "bytes32"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "account",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "sender",
              "type": "address"
            }
          ],
          "name": "RoleGranted",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "bytes32",
              "name": "role",
              "type": "bytes32"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "account",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "sender",
              "type": "address"
            }
          ],
          "name": "RoleRevoked",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_oldStabilityPoolAddress",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "_newStabilityPoolAddress",
              "type": "address"
            }
          ],
          "name": "StabilityPoolAddressChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "from",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "to",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "value",
              "type": "uint256"
            }
          ],
          "name": "Transfer",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "burner",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "bool",
              "name": "isValid",
              "type": "bool"
            }
          ],
          "name": "VEUSDBurnerChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "minter",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "bool",
              "name": "isValid",
              "type": "bool"
            }
          ],
          "name": "VEUSDMinterChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_oldVaultManagerDiamondAddress",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "_newVaultManagerDiamondAddress",
              "type": "address"
            }
          ],
          "name": "VaultManagerDiamondAddressChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_user",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "veUSDTokenBalanceUpdated",
          "type": "event"
        },
        {
          "inputs": [],
          "name": "BRIDGE_MINT_INCREASE_DELAY",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "BRIDGE_PAUSER_ROLE",
          "outputs": [
            {
              "internalType": "bytes32",
              "name": "",
              "type": "bytes32"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "BRIDGE_RISK_MANAGER_ROLE",
          "outputs": [
            {
              "internalType": "bytes32",
              "name": "",
              "type": "bytes32"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "BRIDGE_ROLE",
          "outputs": [
            {
              "internalType": "bytes32",
              "name": "",
              "type": "bytes32"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "DEFAULT_ADMIN_ROLE",
          "outputs": [
            {
              "internalType": "bytes32",
              "name": "",
              "type": "bytes32"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "DOMAIN_SEPARATOR",
          "outputs": [
            {
              "internalType": "bytes32",
              "name": "",
              "type": "bytes32"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "MINT_PAUSER_ROLE",
          "outputs": [
            {
              "internalType": "bytes32",
              "name": "",
              "type": "bytes32"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "MIN_PROTOCOL_SUPPLY_TO_BRIDGE_SUPPLY_RATIO",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "PROTOCOL_BURNER_ROLE",
          "outputs": [
            {
              "internalType": "bytes32",
              "name": "",
              "type": "bytes32"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "PROTOCOL_MINTER_ROLE",
          "outputs": [
            {
              "internalType": "bytes32",
              "name": "",
              "type": "bytes32"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "VERSION",
          "outputs": [
            {
              "internalType": "string",
              "name": "",
              "type": "string"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "spender",
              "type": "address"
            }
          ],
          "name": "allowance",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "spender",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            }
          ],
          "name": "approve",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "balanceOf",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "borrowerOperationsAddress",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "name": "bridgeMintLimitIncreaseProposals",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "newMintLimit",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "executionTime",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "bridgePaused",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "bridgeSupply",
          "outputs": [
            {
              "internalType": "int256",
              "name": "",
              "type": "int256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "name": "bridges",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "timestamp",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "ratePerSecond",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "maxLimit",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "currentLimit",
                  "type": "uint256"
                }
              ],
              "internalType": "struct XERC20.BridgeParameters",
              "name": "minterParams",
              "type": "tuple"
            },
            {
              "components": [
                {
                  "internalType": "uint256",
                  "name": "timestamp",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "ratePerSecond",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "maxLimit",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "currentLimit",
                  "type": "uint256"
                }
              ],
              "internalType": "struct XERC20.BridgeParameters",
              "name": "burnerParams",
              "type": "tuple"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "burn",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_account",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "burn",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_account",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "burnFrom",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_bridge",
              "type": "address"
            }
          ],
          "name": "burningCurrentLimitOf",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "_limit",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_bridge",
              "type": "address"
            }
          ],
          "name": "burningMaxLimitOf",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "_limit",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "canMint",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "decimals",
          "outputs": [
            {
              "internalType": "uint8",
              "name": "",
              "type": "uint8"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "spender",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "subtractedValue",
              "type": "uint256"
            }
          ],
          "name": "decreaseAllowance",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "eip712Domain",
          "outputs": [
            {
              "internalType": "bytes1",
              "name": "fields",
              "type": "bytes1"
            },
            {
              "internalType": "string",
              "name": "name",
              "type": "string"
            },
            {
              "internalType": "string",
              "name": "version",
              "type": "string"
            },
            {
              "internalType": "uint256",
              "name": "chainId",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "verifyingContract",
              "type": "address"
            },
            {
              "internalType": "bytes32",
              "name": "salt",
              "type": "bytes32"
            },
            {
              "internalType": "uint256[]",
              "name": "extensions",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_bridge",
              "type": "address"
            }
          ],
          "name": "executeMintLimitIncreaseProposal",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bytes32",
              "name": "role",
              "type": "bytes32"
            }
          ],
          "name": "getRoleAdmin",
          "outputs": [
            {
              "internalType": "bytes32",
              "name": "",
              "type": "bytes32"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bytes32",
              "name": "role",
              "type": "bytes32"
            },
            {
              "internalType": "uint256",
              "name": "index",
              "type": "uint256"
            }
          ],
          "name": "getRoleMember",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bytes32",
              "name": "role",
              "type": "bytes32"
            }
          ],
          "name": "getRoleMemberCount",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getSupplyRatio",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "supplyRatio",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "governorAddress",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bytes32",
              "name": "role",
              "type": "bytes32"
            },
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "grantRole",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bytes32",
              "name": "role",
              "type": "bytes32"
            },
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "hasRole",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "spender",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "addedValue",
              "type": "uint256"
            }
          ],
          "name": "increaseAllowance",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "vaultManagerDiamondAddress",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "stabilityPoolAddress",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "borrowerOperationsAddress",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "governorAddress",
                  "type": "address"
                },
                {
                  "internalType": "address",
                  "name": "ownerAndAdminRole",
                  "type": "address"
                }
              ],
              "internalType": "struct IveUSDToken_Initializer.InitializerParams",
              "name": "params",
              "type": "tuple"
            }
          ],
          "name": "initialize",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_account",
              "type": "address"
            }
          ],
          "name": "isValidProtocolBurner",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_account",
              "type": "address"
            }
          ],
          "name": "isValidProtocolMinter",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "lockbox",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_vaultManagerDiamondAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_stabilityPoolAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_borrowerOperationsAddress",
              "type": "address"
            }
          ],
          "name": "migrateProtocolContracts",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "minProtocolSupplyToBridgeSupplyRatio",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_account",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "mint",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_bridge",
              "type": "address"
            }
          ],
          "name": "mintingCurrentLimitOf",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "_limit",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_bridge",
              "type": "address"
            }
          ],
          "name": "mintingMaxLimitOf",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "_limit",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "name",
          "outputs": [
            {
              "internalType": "string",
              "name": "",
              "type": "string"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            }
          ],
          "name": "nonces",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "owner",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "pauseBridging",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "spender",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "value",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "deadline",
              "type": "uint256"
            },
            {
              "internalType": "uint8",
              "name": "v",
              "type": "uint8"
            },
            {
              "internalType": "bytes32",
              "name": "r",
              "type": "bytes32"
            },
            {
              "internalType": "bytes32",
              "name": "s",
              "type": "bytes32"
            }
          ],
          "name": "permit",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_bridge",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_newMintingLimit",
              "type": "uint256"
            }
          ],
          "name": "proposeMintLimitIncrease",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "protocolSupply",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "initializer_",
              "type": "address"
            }
          ],
          "name": "registerInitializer",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "registeredInitializer",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bytes32",
              "name": "role",
              "type": "bytes32"
            },
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "renounceRole",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_poolAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_receiver",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "returnFromPool",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_bridge",
              "type": "address"
            }
          ],
          "name": "revokeMintLimitIncreaseProposal",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bytes32",
              "name": "role",
              "type": "bytes32"
            },
            {
              "internalType": "address",
              "name": "account",
              "type": "address"
            }
          ],
          "name": "revokeRole",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_sender",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_poolAddress",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "sendToPool",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_bridge",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_mintingLimit",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_burningLimit",
              "type": "uint256"
            }
          ],
          "name": "setLimits",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_lockbox",
              "type": "address"
            }
          ],
          "name": "setLockbox",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_ratio",
              "type": "uint256"
            }
          ],
          "name": "setMinProtocolSupplyToBridgeSupplyRatio",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "stabilityPoolAddress",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bytes4",
              "name": "interfaceId",
              "type": "bytes4"
            }
          ],
          "name": "supportsInterface",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "symbol",
          "outputs": [
            {
              "internalType": "string",
              "name": "",
              "type": "string"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "totalSupply",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "recipient",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            }
          ],
          "name": "transfer",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "sender",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "recipient",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "amount",
              "type": "uint256"
            }
          ],
          "name": "transferFrom",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "unpauseBridging",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bool",
              "name": "_canMint",
              "type": "bool"
            }
          ],
          "name": "updateMinting",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "vaultManagerDiamondAddress",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        }
      ],
      "inheritedFunctions": {}
    },
    "VaultManager": {
      "address": "0x5f5A5c9aA4C781972D8Fd417138CdcfC9874b73B",
      "abi": [
        {
          "inputs": [],
          "name": "CollateralNotInVault",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "DiscountIsZero",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "actualFee",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "maxFee",
              "type": "uint256"
            }
          ],
          "name": "FeeExceedsMaxFee",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "VEUSDRedeemed",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "redemptionFee",
              "type": "uint256"
            }
          ],
          "name": "FeeExceedsRedemption",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "ICR",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "MCR",
              "type": "uint256"
            }
          ],
          "name": "ICRBelowMCR",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InsufficientVEUSDBalance",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InsufficientVaultsInSystem",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidAbsorptionParams",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidBurner",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "targetAICR",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "actualAICR",
              "type": "uint256"
            }
          ],
          "name": "InvalidHintAICR",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidInputLength",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidMinter",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidRedeemer",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidRedemptionHint",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "InvalidSender",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "maxFeePercentage",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "decimalPrecision",
              "type": "uint256"
            }
          ],
          "name": "MaxFeeTooHigh",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "maxFeePercentage",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "redemptionFeeFloor",
              "type": "uint256"
            }
          ],
          "name": "MaxFeeTooLow",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NoCollateralDrawn",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NotBorrowerOperations",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NotController",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "NotRewarder",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "OnlyVaultedgeController",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "RedeemerBalanceTooHigh",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "RedemptionsEnabledAlreadySet",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "RedemptionsNotEnabled",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "TCRBelowMCR",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "vaultDebt",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "minNetDebt",
              "type": "uint256"
            }
          ],
          "name": "VaultDebtBelowMinNetDebt",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "VaultNotActive",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ZeroAmount",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_baseRate",
              "type": "uint256"
            }
          ],
          "name": "BaseRateUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "token",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "collAmount",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "collToSendToSP",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "collToRedistribute",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "collSurplus",
              "type": "uint256"
            }
          ],
          "name": "CollateralDistribution",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "borrower",
              "type": "address"
            }
          ],
          "name": "CollateralSurplusCreated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "vaultDebt",
              "type": "uint256"
            }
          ],
          "name": "DistributionValidated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "liquidator",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "VEUSDAmount",
              "type": "uint256"
            }
          ],
          "name": "GasCompensationSent",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "borrower",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "interest",
              "type": "uint256"
            }
          ],
          "name": "InterestApplied",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_token",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_L_Coll",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_L_VEUSDDebtReward",
              "type": "uint256"
            }
          ],
          "name": "LRewardsUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_Coll_Address",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_L_Coll",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_L_VEUSDDebt",
              "type": "uint256"
            }
          ],
          "name": "LTermsUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "token",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "L_VEUSDInterest",
              "type": "uint256"
            }
          ],
          "name": "L_VEUSDInterestUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_lastFeeOpTime",
              "type": "uint256"
            }
          ],
          "name": "LastFeeOpTimeUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "liquidatedAmount",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "totalVEUSDGasCompensation",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "address[]",
              "name": "totalCollTokens",
              "type": "address[]"
            },
            {
              "indexed": false,
              "internalType": "uint256[]",
              "name": "totalCollAmounts",
              "type": "uint256[]"
            },
            {
              "indexed": false,
              "internalType": "address[]",
              "name": "totalCollGasCompTokens",
              "type": "address[]"
            },
            {
              "indexed": false,
              "internalType": "uint256[]",
              "name": "totalCollGasCompAmounts",
              "type": "uint256[]"
            }
          ],
          "name": "Liquidation",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "borrower",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "bool",
              "name": "inRecoveryMode",
              "type": "bool"
            }
          ],
          "name": "LiquidationInitiated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "borrower",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "string",
              "name": "reason",
              "type": "string"
            }
          ],
          "name": "LiquidationSkipped",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "borrower",
              "type": "address"
            }
          ],
          "name": "PendingRewards",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [],
          "name": "RecoveryModeExited",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "borrower",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "string",
              "name": "strategy",
              "type": "string"
            }
          ],
          "name": "RecoveryModeLiquidationStrategy",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_attemptedVEUSDAmount",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_actualVEUSDAmount",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "VEUSDfee",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "address[]",
              "name": "tokens",
              "type": "address[]"
            },
            {
              "indexed": false,
              "internalType": "uint256[]",
              "name": "amounts",
              "type": "uint256[]"
            }
          ],
          "name": "Redemption",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "bool",
              "name": "_enabled",
              "type": "bool"
            }
          ],
          "name": "RedemptionsEnabledUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "debtOffset",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "collateralVC",
              "type": "uint256"
            }
          ],
          "name": "StabilityPoolUsed",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_unix",
              "type": "uint256"
            }
          ],
          "name": "SystemSnapshotsUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "bool",
              "name": "inRecoveryMode",
              "type": "bool"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "TCR",
              "type": "uint256"
            }
          ],
          "name": "SystemStateSnapshot",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "token",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newTotalStakes",
              "type": "uint256"
            }
          ],
          "name": "TotalStakesUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newIndex",
              "type": "uint256"
            }
          ],
          "name": "VaultIndexUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_debt",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "enum VaultManagerOperation",
              "name": "_operation",
              "type": "uint8"
            }
          ],
          "name": "VaultLiquidated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_unix",
              "type": "uint256"
            }
          ],
          "name": "VaultSnapshotsUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_debt",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "address[]",
              "name": "_tokens",
              "type": "address[]"
            },
            {
              "indexed": false,
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            },
            {
              "indexed": false,
              "internalType": "enum VaultManagerOperation",
              "name": "operation",
              "type": "uint8"
            }
          ],
          "name": "VaultUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_account",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "VeUsdBurned",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "addVaultOwnerToArray",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "index",
              "type": "uint256"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "applyPendingRewards",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_vaultArray",
              "type": "address[]"
            },
            {
              "internalType": "address",
              "name": "_liquidator",
              "type": "address"
            }
          ],
          "name": "batchLiquidateVaults",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_account",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "burn",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "calcDecayedBaseRate",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_newInterestTimeWindow",
              "type": "uint256"
            }
          ],
          "name": "changeInterestTimeWindow",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_debtIncrease",
              "type": "uint256"
            },
            {
              "internalType": "bool",
              "name": "_isDebtIncrease",
              "type": "bool"
            }
          ],
          "name": "changeVaultDebt",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "newDebt",
              "type": "uint256"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "checkRecoveryMode",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_VEUSDDebt",
              "type": "uint256"
            }
          ],
          "name": "decayBaseRateFromBorrowingAndCalculateFee",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "VEUSDDebt",
              "type": "uint256"
            }
          ],
          "name": "getBorrowingFee",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_VEUSDDebt",
              "type": "uint256"
            }
          ],
          "name": "getBorrowingFeeWithDecay",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getBorrowingRate",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getBorrowingRateWithDecay",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "getCollateralProportionDenominator",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getCollateralProportionNumerator",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "getCurrentAICR",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "getCurrentICR",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "getCurrentVaultState",
          "outputs": [
            {
              "internalType": "address[]",
              "name": "",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "getEntireDebtAndColls",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "internalType": "address[]",
              "name": "",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "internalType": "address[]",
              "name": "",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_token",
              "type": "address"
            }
          ],
          "name": "getL_Coll",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_token",
              "type": "address"
            }
          ],
          "name": "getL_VEUSD",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "getPendingCollRewards",
          "outputs": [
            {
              "internalType": "address[]",
              "name": "",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "getPendingVEUSDDebtReward",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_ETHDrawn",
              "type": "uint256"
            }
          ],
          "name": "getRedemptionFeeWithDecay",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getRedemptionRate",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getRedemptionRateWithDecay",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_token",
              "type": "address"
            }
          ],
          "name": "getRewardSnapshotColl",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_token",
              "type": "address"
            }
          ],
          "name": "getRewardSnapshotVEUSD",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getTCR",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_token",
              "type": "address"
            }
          ],
          "name": "getTotalStake",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "getVaultColls",
          "outputs": [
            {
              "internalType": "address[]",
              "name": "",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "getVaultDebt",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_index",
              "type": "uint256"
            }
          ],
          "name": "getVaultFromVaultOwnersArray",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getVaultOwnersCount",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_token",
              "type": "address"
            }
          ],
          "name": "getVaultStake",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "getVaultStatus",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "getVaultVC",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "hasPendingRewards",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_newCollateral",
              "type": "address"
            }
          ],
          "name": "interestInitCollateral",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "isVaultActive",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "liquidate",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "rewardAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "collAddress",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "rewardAmount",
              "type": "uint256"
            }
          ],
          "name": "notifyRewardAmount",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_VEUSDamount",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_VEUSDMaxFee",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_firstRedemptionHint",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_upperPartialRedemptionHint",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_lowerPartialRedemptionHint",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_partialRedemptionHintAICR",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_maxIterations",
              "type": "uint256"
            }
          ],
          "name": "redeemCollateral",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_VEUSDamount",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_VEUSDMaxFee",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_target",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_upperHint",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_lowerHint",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_hintAICR",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_collToRedeem",
              "type": "address"
            }
          ],
          "name": "redeemCollateralSingle",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_status",
              "type": "uint256"
            }
          ],
          "name": "removeStakeAndCloseVault",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "num",
              "type": "uint256"
            }
          ],
          "name": "setVaultStatus",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "tickInterest",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_rewarder",
              "type": "address"
            },
            {
              "internalType": "bool",
              "name": "_isRewarder",
              "type": "bool"
            }
          ],
          "name": "toggleRewarder",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "newBaseRate",
              "type": "uint256"
            }
          ],
          "name": "updateBaseRate",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "bool",
              "name": "_enabled",
              "type": "bool"
            }
          ],
          "name": "updateRedemptionsEnabled",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "contract IActivePool",
              "name": "_activePool",
              "type": "address"
            },
            {
              "internalType": "address[]",
              "name": "_tokens",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "updateSystemSnapshots_excludeCollRemainder",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_ids",
              "type": "address[]"
            }
          ],
          "name": "updateUnderCollateralizedVaults",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            },
            {
              "internalType": "address[]",
              "name": "_tokens",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "updateVaultCollAndStakeAndTotalStakes",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            }
          ],
          "name": "updateVaultRewardSnapshots",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_borrowers",
              "type": "address[]"
            },
            {
              "internalType": "address[]",
              "name": "_lowerHints",
              "type": "address[]"
            },
            {
              "internalType": "address[]",
              "name": "_upperHints",
              "type": "address[]"
            }
          ],
          "name": "updateVaults",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "inheritedFunctions": {}
    },
    "BorrowerOperations": {
      "address": "0x2D9F3098f5BE5f60f6Dba98adb9e00D290817413",
      "abi": [
        {
          "inputs": [],
          "name": "AddressZero",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__BalanceCheckFailed",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__CannotCloseVaultInRecoveryMode",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__CollateralIndexMismatch",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__EmptyAmounts",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__FeeTooHigh",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__ICRMustBeAboveCCR",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__ICRMustBeAboveMCR",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__ICRMustNotDecreaseInRecoveryMode",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__IncorrectInput",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__InsufficientVEUSDBalance",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__InvalidMaxFeePercentage",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__InvalidVEUSDRepayment",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__LeverUpNotEnabled",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__MaxSlippageExceeded",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__NetDebtBelowMinimum",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__NoCollWithdrawalInRecoveryMode",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__NoZeroAdjustment",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__OnlyVaultManager",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__TCRMustBeAboveCCR",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__TooManyCollaterals",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__VaultMustBeInactive",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__VaultNotActive",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "BorrowerOperations__VaultStatusNotActive",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ControllerAlreadyInitialized",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint8",
              "name": "version",
              "type": "uint8"
            }
          ],
          "name": "Initialized",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_VEUSDFee",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "_caller",
              "type": "address"
            }
          ],
          "name": "VEUSDBorrowingFeePaid",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_VEUSDVariableFee",
              "type": "uint256"
            }
          ],
          "name": "VariableFeePaid",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "arrayIndex",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "_caller",
              "type": "address"
            }
          ],
          "name": "VaultCreated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_borrower",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_debt",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "address[]",
              "name": "_tokens",
              "type": "address[]"
            },
            {
              "indexed": false,
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            },
            {
              "indexed": false,
              "internalType": "enum BorrowerOperationsBase.BorrowerOperation",
              "name": "operation",
              "type": "uint8"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "_caller",
              "type": "address"
            }
          ],
          "name": "VaultUpdated",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collsIn",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amountsIn",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_leverages",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_maxSlippages",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256",
              "name": "_VEUSDAmount",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_upperHint",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_lowerHint",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_maxFeePercentage",
              "type": "uint256"
            }
          ],
          "name": "addCollLeverUp",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collsIn",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amountsIn",
              "type": "uint256[]"
            },
            {
              "internalType": "address[]",
              "name": "_collsOut",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amountsOut",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256",
              "name": "_VEUSDChange",
              "type": "uint256"
            },
            {
              "internalType": "bool",
              "name": "_isDebtIncrease",
              "type": "bool"
            },
            {
              "internalType": "address",
              "name": "_upperHint",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_lowerHint",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_maxFeePercentage",
              "type": "uint256"
            }
          ],
          "name": "adjustVault",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collsIn",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amountsIn",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256",
              "name": "_VEUSDChange",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_upperHint",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_lowerHint",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_maxFeePercentage",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_adjustedAddress",
              "type": "address"
            }
          ],
          "name": "adjustVaultFor",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "closeVault",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collsOut",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amountsOut",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_maxSlippages",
              "type": "uint256[]"
            }
          ],
          "name": "closeVaultUnlever",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getEntireSystemColl",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getEntireSystemDebt",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_vaultManagerAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_activePoolAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_defaultPoolAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_gasPoolAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_collSurplusPoolAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_sortedVaultsAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_veusdTokenAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_controllerAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_debtCapManager",
              "type": "address"
            }
          ],
          "name": "initialize",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_VEUSDInterest",
              "type": "uint256"
            }
          ],
          "name": "mintVEUSDInterestFee",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_maxFeePercentage",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_VEUSDAmount",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_upperHint",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_lowerHint",
              "type": "address"
            },
            {
              "internalType": "address[]",
              "name": "_colls",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "openVault",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_maxFeePercentage",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_VEUSDAmount",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_upperHint",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_lowerHint",
              "type": "address"
            },
            {
              "internalType": "address[]",
              "name": "_colls",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            },
            {
              "internalType": "address",
              "name": "_vaultOpenAddress",
              "type": "address"
            }
          ],
          "name": "openVaultFor",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_maxFeePercentage",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_VEUSDAmount",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_upperHint",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_lowerHint",
              "type": "address"
            },
            {
              "internalType": "address[]",
              "name": "_colls",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_leverages",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_maxSlippages",
              "type": "uint256[]"
            }
          ],
          "name": "openVaultLeverUp",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collsOut",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amountsOut",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_maxSlippages",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256",
              "name": "_VEUSDAmount",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_upperHint",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_lowerHint",
              "type": "address"
            }
          ],
          "name": "withdrawCollUnleverUp",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "inheritedFunctions": {}
    },
    "SortedVaults": {
      "address": "0xcfc5E386Db055C7B819741aa4f1224518f468745",
      "abi": [
        {
          "inputs": [],
          "name": "AICRMustBePositive",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "AddressesAlreadySet",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "DuplicateNode",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ExternalCallerNotAllowed",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "IdCannotBeZero",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "IdNotFound",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ListIsFull",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "SizeCannotBeZero",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint8",
              "name": "version",
              "type": "uint8"
            }
          ],
          "name": "Initialized",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_id",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_AICR",
              "type": "uint256"
            }
          ],
          "name": "NodeAdded",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_id",
              "type": "address"
            }
          ],
          "name": "NodeRemoved",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_id",
              "type": "address"
            }
          ],
          "name": "UnderCollateralizedVaultAdded",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_id",
              "type": "address"
            }
          ],
          "name": "UnderCollateralizedVaultRemoved",
          "type": "event"
        },
        {
          "inputs": [],
          "name": "boostMinuteDecayFactor",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_newBoostMinuteDecayFactor",
              "type": "uint256"
            }
          ],
          "name": "changeBoostMinuteDecayFactor",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_newGlobalBoostMultiplier",
              "type": "uint256"
            }
          ],
          "name": "changeGlobalBoostMultiplier",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_id",
              "type": "address"
            }
          ],
          "name": "contains",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "data",
          "outputs": [
            {
              "internalType": "address",
              "name": "head",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "tail",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "maxSize",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "size",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_boostedAICR",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_prevId",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_nextId",
              "type": "address"
            }
          ],
          "name": "findInsertPosition",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_id",
              "type": "address"
            }
          ],
          "name": "getBoost",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_id",
              "type": "address"
            }
          ],
          "name": "getDecayedBoost",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getFirst",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getLast",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getMaxSize",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_id",
              "type": "address"
            }
          ],
          "name": "getNext",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_id",
              "type": "address"
            }
          ],
          "name": "getNode",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            },
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_id",
              "type": "address"
            }
          ],
          "name": "getOldBoostedAICR",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_id",
              "type": "address"
            }
          ],
          "name": "getPrev",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getSize",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_id",
              "type": "address"
            }
          ],
          "name": "getTimeSinceBoostUpdated",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getUnderCollateralizedVaultsSize",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "globalBoostFactor",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_size",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_vaultManagerAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_borrowerOperationsAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_vaultManagerRedemptionsAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_vaultedgeControllerAddress",
              "type": "address"
            }
          ],
          "name": "initialize",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_id",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_AICR",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_prevId",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_nextId",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_feeAsPercentOfTotal",
              "type": "uint256"
            }
          ],
          "name": "insert",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "isEmpty",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "isFull",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_id",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_newAICR",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_prevId",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_nextId",
              "type": "address"
            }
          ],
          "name": "reInsert",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_ids",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_newAICRs",
              "type": "uint256[]"
            },
            {
              "internalType": "address[]",
              "name": "_prevIds",
              "type": "address[]"
            },
            {
              "internalType": "address[]",
              "name": "_nextIds",
              "type": "address[]"
            }
          ],
          "name": "reInsertMany",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_id",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_newAICR",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_prevId",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_nextId",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_feeAsPercentOfAddedVC",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_addedVCIn",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_VCBeforeAdjustment",
              "type": "uint256"
            }
          ],
          "name": "reInsertWithNewBoost",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_id",
              "type": "address"
            }
          ],
          "name": "remove",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "name": "underCollateralizedVaults",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "underCollateralizedVaultsSize",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_id",
              "type": "address"
            },
            {
              "internalType": "bool",
              "name": "_isUnderCollateralized",
              "type": "bool"
            }
          ],
          "name": "updateUnderCollateralizedVault",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_boostedAICR",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_prevId",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_nextId",
              "type": "address"
            }
          ],
          "name": "validInsertPosition",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        }
      ],
      "inheritedFunctions": {}
    },
    "HintHelpers": {
      "address": "0xCddDF9D1489A3BDe23BFDB6149E65CE3C8563c44",
      "abi": [
        {
          "inputs": [],
          "name": "AddressZero",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ControllerAlreadyInitialized",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint8",
              "name": "version",
              "type": "uint8"
            }
          ],
          "name": "Initialized",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_CR",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_numTrials",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_inputRandomSeed",
              "type": "uint256"
            }
          ],
          "name": "getApproxHint",
          "outputs": [
            {
              "internalType": "address",
              "name": "hintAddress",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "diff",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "latestRandomSeed",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getEntireSystemColl",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getEntireSystemDebt",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "confidenceMultiplier",
              "type": "uint256"
            }
          ],
          "name": "getRecommendedTrials",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "recommendedTrials",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_VEUSDamount",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "_target",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_collToRedeem",
              "type": "address"
            }
          ],
          "name": "getRedemptionHintCollateralSingle",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "tokenAmountToRedeem",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "partialRedemptionHintAICR",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "truncatedVEUSDamount",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_VEUSDamount",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_maxIterations",
              "type": "uint256"
            }
          ],
          "name": "getRedemptionHints",
          "outputs": [
            {
              "internalType": "address",
              "name": "firstRedemptionHint",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "partialRedemptionHintAICR",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "truncatedVEUSDamount",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_sortedVaultsAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_vaultManagerAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_controllerAddress",
              "type": "address"
            }
          ],
          "name": "initialize",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "sortedVaults",
          "outputs": [
            {
              "internalType": "contract ISortedVaults",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "vaultManager",
          "outputs": [
            {
              "internalType": "contract IVaultManager",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        }
      ],
      "inheritedFunctions": {}
    },
    "ActivePool": {
      "address": "0xeCECE7cb771de842Ad06012087F384d33251B77b",
      "abi": [
        {
          "inputs": [],
          "name": "AddressZero",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ControllerAlreadyInitialized",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "ActivePoolBalanceUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "indexed": false,
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "ActivePoolBalancesUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_VEUSDDebt",
              "type": "uint256"
            }
          ],
          "name": "ActivePoolVEUSDDebtUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "_to",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "CollateralSent",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "indexed": false,
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "_to",
              "type": "address"
            }
          ],
          "name": "CollateralsSent",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newBalance",
              "type": "uint256"
            }
          ],
          "name": "ETHBalanceUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_to",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "EtherSent",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint8",
              "name": "version",
              "type": "uint8"
            }
          ],
          "name": "Initialized",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newBalance",
              "type": "uint256"
            }
          ],
          "name": "VEUSDBalanceUpdated",
          "type": "event"
        },
        {
          "inputs": [],
          "name": "VEUSDDebt",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "addCollateralType",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "contract IEdgeStratRewards",
              "name": "collAddress",
              "type": "address"
            }
          ],
          "name": "claimColRewards",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "decreaseDebt",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getAllCollateral",
          "outputs": [
            {
              "internalType": "address[]",
              "name": "",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            }
          ],
          "name": "getAmountsSubsetSystem",
          "outputs": [
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getCollateral",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getCollateralVC",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getVC",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "totalVC",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getVCAndRVC",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "totalVC",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalRVC",
              "type": "uint256"
            },
            {
              "internalType": "uint256[]",
              "name": "VCPerCollateral",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getVCAndRVCSystem",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "totalVC",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalRVC",
              "type": "uint256"
            },
            {
              "internalType": "uint256[]",
              "name": "VCPerCollateral",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getVCSystem",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "totalVCSystem",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getVEUSDDebt",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_debtIncrease",
              "type": "uint256"
            }
          ],
          "name": "increaseDebt",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrowerOperationsAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_vaultManagerAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_stabilityPoolAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_defaultPoolAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_controllerAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_vaultManagerLiquidationsAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_vaultManagerRedemptionsAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_collSurplusPoolAddress",
              "type": "address"
            }
          ],
          "name": "initialize",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_tokens",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "receiveCollateral",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_to",
              "type": "address"
            },
            {
              "internalType": "address[]",
              "name": "_tokens",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "sendCollaterals",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_to",
              "type": "address"
            },
            {
              "internalType": "address[]",
              "name": "_tokens",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "sendCollateralsUnwrap",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_to",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_token",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "sendSingleCollateral",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_to",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_token",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "sendSingleCollateralUnwrap",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "inheritedFunctions": {}
    },
    "DefaultPool": {
      "address": "0xE19173d56F212A40C5BBC2070b91cdD175655470",
      "abi": [
        {
          "inputs": [],
          "name": "AddressZero",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ControllerAlreadyInitialized",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "_to",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "CollateralSent",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "DefaultPoolBalanceUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "indexed": false,
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "DefaultPoolBalancesUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_VEUSDDebt",
              "type": "uint256"
            }
          ],
          "name": "DefaultPoolVEUSDDebtUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newBalance",
              "type": "uint256"
            }
          ],
          "name": "ETHBalanceUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_to",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "EtherSent",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint8",
              "name": "version",
              "type": "uint8"
            }
          ],
          "name": "Initialized",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newBalance",
              "type": "uint256"
            }
          ],
          "name": "VEUSDBalanceUpdated",
          "type": "event"
        },
        {
          "inputs": [],
          "name": "VEUSDDebt",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "addCollateralType",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "decreaseDebt",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getAllAmounts",
          "outputs": [
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getAllCollateral",
          "outputs": [
            {
              "internalType": "address[]",
              "name": "",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            }
          ],
          "name": "getAmountsSubset",
          "outputs": [
            {
              "internalType": "uint256[]",
              "name": "amounts",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256[]",
              "name": "controllerIndices",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getCollateral",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getCollateralVC",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getVC",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "totalVC",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getVCAndRVC",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "totalVC",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "totalRVC",
              "type": "uint256"
            },
            {
              "internalType": "uint256[]",
              "name": "VCPerCollateral",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getVEUSDDebt",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "increaseDebt",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_vaultManagerAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_vaultManagerLiquidationsAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_activePoolAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_controllerAddress",
              "type": "address"
            }
          ],
          "name": "initialize",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "logExtraCollateral",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_tokens",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "receiveCollateral",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_tokens",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "sendCollsToActivePool",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "inheritedFunctions": {}
    },
    "StabilityPool": {
      "address": "0x88c226601868DfCD1ADac6fA54c7Ee85529a1440",
      "abi": [
        {
          "inputs": [],
          "name": "AddressZero",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ControllerAlreadyInitialized",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "StabilityPool__ArrayLengthMismatch",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "StabilityPool__DebtExceedsTotalDeposits",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "StabilityPool__InsufficientVEUSDTransferred",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "StabilityPool__NoWithdrawWithUnderCollateralizedVaults",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "StabilityPool__NonZeroAmountRequired",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "StabilityPool__NonZeroDepositRequired",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "StabilityPool__NotActivePool",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "StabilityPool__NotTimelock",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "StabilityPool__NotVaultManager",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "StabilityPool__ProductFactorZero",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "StabilityPool__SwapArrayLengthMismatch",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "StabilityPool__UnrouteBalanceMismatch",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "StabilityPool__VEUSDLossExceedsLimit",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "StabilityPool__WithdrawalBelowMinimum",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "StabilityPool__WrongFunctionCaller",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_to",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "indexed": false,
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "CollateralSent",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_depositor",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_P",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_G",
              "type": "uint256"
            }
          ],
          "name": "DepositSnapshotUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_depositor",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_ETH",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_VEUSDLoss",
              "type": "uint256"
            }
          ],
          "name": "ETHGainWithdrawn",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_to",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "EtherSent",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_G",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint128",
              "name": "_scale",
              "type": "uint128"
            }
          ],
          "name": "G_Updated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_depositor",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "indexed": false,
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_VEUSDLoss",
              "type": "uint256"
            }
          ],
          "name": "GainsWithdrawn",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint8",
              "name": "version",
              "type": "uint8"
            }
          ],
          "name": "Initialized",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_P",
              "type": "uint256"
            }
          ],
          "name": "P_Updated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_depositor",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "indexed": false,
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "PendingCollGainsUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_asset",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_S",
              "type": "uint256"
            },
            {
              "indexed": false,
              "internalType": "uint128",
              "name": "_scale",
              "type": "uint128"
            }
          ],
          "name": "S_Updated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint128",
              "name": "_currentScale",
              "type": "uint128"
            }
          ],
          "name": "ScaleUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address[]",
              "name": "assets",
              "type": "address[]"
            },
            {
              "indexed": false,
              "internalType": "uint256[]",
              "name": "amounts",
              "type": "uint256[]"
            }
          ],
          "name": "StabilityPoolBalanceUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address[]",
              "name": "assets",
              "type": "address[]"
            },
            {
              "indexed": false,
              "internalType": "uint256[]",
              "name": "amounts",
              "type": "uint256[]"
            }
          ],
          "name": "StabilityPoolBalancesUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newBalance",
              "type": "uint256"
            }
          ],
          "name": "StabilityPoolETHBalanceUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newBalance",
              "type": "uint256"
            }
          ],
          "name": "StabilityPoolVEUSDBalanceUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_depositor",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_newDeposit",
              "type": "uint256"
            }
          ],
          "name": "UserDepositChanged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_depositor",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_VEUSDAmount",
              "type": "uint256"
            }
          ],
          "name": "VEUSDFromRewardSwap",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_depositor",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "_Vaultedge",
              "type": "uint256"
            }
          ],
          "name": "VaultedgePaidToDepositor",
          "type": "event"
        },
        {
          "inputs": [],
          "name": "P",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "SCALE_FACTOR",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "addCollateralType",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "borrowerOperations",
          "outputs": [
            {
              "internalType": "contract IBorrowerOperations",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "claimRewards",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_veusdMinAmountTotal",
              "type": "uint256"
            },
            {
              "internalType": "address[]",
              "name": "_swapAssets",
              "type": "address[]"
            },
            {
              "internalType": "bool",
              "name": "_reinvest",
              "type": "bool"
            }
          ],
          "name": "claimRewardsSwap",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "amountFromSwap",
              "type": "uint256"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "communityIssuance",
          "outputs": [
            {
              "internalType": "contract ICommunityIssuance",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "currentScale",
          "outputs": [
            {
              "internalType": "uint128",
              "name": "",
              "type": "uint128"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "name": "depositSnapshots",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "P",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "G",
              "type": "uint256"
            },
            {
              "internalType": "uint128",
              "name": "scale",
              "type": "uint128"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "name": "deposits",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getAllCollateral",
          "outputs": [
            {
              "internalType": "address[]",
              "name": "",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getCollateral",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_depositor",
              "type": "address"
            }
          ],
          "name": "getCompoundedVEUSDDeposit",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_depositor",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getDepositSnapshotS",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_depositor",
              "type": "address"
            }
          ],
          "name": "getDepositorGains",
          "outputs": [
            {
              "internalType": "address[]",
              "name": "",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_depositor",
              "type": "address"
            }
          ],
          "name": "getDepositorVaultedgeGain",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getEntireSystemColl",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getEntireSystemDebt",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "_time",
              "type": "uint256"
            }
          ],
          "name": "getEstimatedVaultedgePoolRewards",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getMaxAmountToOffset",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getTotalVEUSDDeposits",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getVC",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrowerOperationsAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_vaultManagerAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_activePoolAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_veusdTokenAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_sortedVaultsAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_communityIssuanceAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_controllerAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_vaultManagerLiquidationsAddress",
              "type": "address"
            }
          ],
          "name": "initialize",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "name": "lastAssetError_Offset",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "lastVEUSDLossError_Offset",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "lastVaultedgeError",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_debtToOffset",
              "type": "uint256"
            },
            {
              "internalType": "address[]",
              "name": "_tokens",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amountsAdded",
              "type": "uint256[]"
            }
          ],
          "name": "offset",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "provideToSP",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_tokens",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "receiveCollateral",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "name": "scaleToG",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            },
            {
              "internalType": "uint128",
              "name": "",
              "type": "uint128"
            }
          ],
          "name": "scaleToSum",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_communityIssuanceAddress",
              "type": "address"
            }
          ],
          "name": "setGovernanceTokenIssuanceAddress",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "sortedVaults",
          "outputs": [
            {
              "internalType": "contract ISortedVaults",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "totalVEUSDDeposits",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "vaultManager",
          "outputs": [
            {
              "internalType": "contract IVaultManager",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "vaultManagerLiquidationsAddress",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "veusdToken",
          "outputs": [
            {
              "internalType": "contract IveUSDToken",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "withdrawFromSP",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "inheritedFunctions": {}
    },
    "CollSurplusPool": {
      "address": "0x7570b69502061f8B4dD98e7ADB50DeB1583224Db",
      "abi": [
        {
          "inputs": [],
          "name": "AddressZero",
          "type": "error"
        },
        {
          "inputs": [],
          "name": "ControllerAlreadyInitialized",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "_account",
              "type": "address"
            }
          ],
          "name": "CollBalanceUpdated",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_to",
              "type": "address"
            }
          ],
          "name": "CollateralSent",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint8",
              "name": "version",
              "type": "uint8"
            }
          ],
          "name": "Initialized",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_account",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "thisRedemptionBonus",
              "type": "uint256"
            }
          ],
          "name": "RedemptionBonusLogged",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "_to",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "thisRedemptionBonus",
              "type": "uint256"
            }
          ],
          "name": "RedemptionBonusSent",
          "type": "event"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_account",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "_amount",
              "type": "uint256"
            }
          ],
          "name": "accountRedemptionBonus",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_account",
              "type": "address"
            },
            {
              "internalType": "address[]",
              "name": "_tokens",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "accountSurplus",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "addCollateralType",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "claimCollateral",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getAllCollateral",
          "outputs": [
            {
              "internalType": "address[]",
              "name": "",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_account",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getAmountClaimable",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_account",
              "type": "address"
            }
          ],
          "name": "getAmountsClaimable",
          "outputs": [
            {
              "internalType": "address[]",
              "name": "",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getCollVC",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getCollateral",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getEntireSystemColl",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getEntireSystemDebt",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_account",
              "type": "address"
            }
          ],
          "name": "getRedemptionBonus",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getTotalRedemptionBonus",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_account",
              "type": "address"
            }
          ],
          "name": "hasClaimableCollateral",
          "outputs": [
            {
              "internalType": "bool",
              "name": "",
              "type": "bool"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_borrowerOperationsAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_vaultManagerLiquidationsAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_vaultManagerRedemptionsAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_activePoolAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_defaultPoolAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_controllerAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_veusdTokenAddress",
              "type": "address"
            }
          ],
          "name": "initialize",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_tokens",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_amounts",
              "type": "uint256[]"
            }
          ],
          "name": "receiveCollateral",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "name": "redemptionBonus",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "totalRedemptionBonus",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        }
      ],
      "inheritedFunctions": {}
    },
    "DebtCapManager": {
      "address": "0x59a49B158394694bcC2EF94dC1d2EA0086d54234",
      "abi": [
        {
          "inputs": [],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "inputs": [],
          "name": "AddressZero",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "caller",
              "type": "address"
            }
          ],
          "name": "NotBorrowerOperations",
          "type": "error"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "caller",
              "type": "address"
            }
          ],
          "name": "NotRiskManagerOrOwner",
          "type": "error"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "collateral",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "debt",
              "type": "uint256"
            }
          ],
          "name": "CurrentDebtPerCollateralSet",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "collateral",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "uint256",
              "name": "debtCap",
              "type": "uint256"
            }
          ],
          "name": "DebtCapPerCollateralSet",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint8",
              "name": "version",
              "type": "uint8"
            }
          ],
          "name": "Initialized",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": true,
              "internalType": "address",
              "name": "previousOwner",
              "type": "address"
            },
            {
              "indexed": true,
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "OwnershipTransferred",
          "type": "event"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "address",
              "name": "oldRiskManager",
              "type": "address"
            },
            {
              "indexed": false,
              "internalType": "address",
              "name": "newRiskManager",
              "type": "address"
            }
          ],
          "name": "RiskManagerSet",
          "type": "event"
        },
        {
          "inputs": [],
          "name": "VERSION",
          "outputs": [
            {
              "internalType": "string",
              "name": "",
              "type": "string"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "borrowerOperations",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_debtIncreases",
              "type": "uint256[]"
            }
          ],
          "name": "checkDebtCapsPerCollateralsIncrease",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "totalDebt",
              "type": "uint256"
            }
          ],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "_totalDebtIncrease",
              "type": "uint256"
            },
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_collateralWeights",
              "type": "uint256[]"
            }
          ],
          "name": "checkDebtCapsPerCollateralsIncreaseByWeight",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getCurrentDebtPerCollateral",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "currentDebt",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            }
          ],
          "name": "getCurrentDebtPerCollaterals",
          "outputs": [
            {
              "internalType": "uint256[]",
              "name": "currentDebts",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_collateral",
              "type": "address"
            }
          ],
          "name": "getDebtCapPerCollateral",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "debtCap",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            }
          ],
          "name": "getDebtCapPerCollaterals",
          "outputs": [
            {
              "internalType": "uint256[]",
              "name": "debtCaps",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            }
          ],
          "name": "getDebtInfoPerCollaterals",
          "outputs": [
            {
              "internalType": "uint256[]",
              "name": "currentDebts",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256[]",
              "name": "debtCaps",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_riskManager",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_borrowerOperations",
              "type": "address"
            }
          ],
          "name": "initialize",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "owner",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "renounceOwnership",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "riskManager",
          "outputs": [
            {
              "internalType": "address",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_debts",
              "type": "uint256[]"
            }
          ],
          "name": "setCurrentDebtPerCollaterals",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address[]",
              "name": "_collaterals",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "_debtCaps",
              "type": "uint256[]"
            }
          ],
          "name": "setDebtCapPerCollaterals",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_riskManager",
              "type": "address"
            }
          ],
          "name": "setRiskManager",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "newOwner",
              "type": "address"
            }
          ],
          "name": "transferOwnership",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        }
      ],
      "inheritedFunctions": {}
    },
    "DebtCapLens": {
      "address": "0x368A5eAc605C2E62122F753Ec58A526b125e1E69",
      "abi": [
        {
          "inputs": [],
          "stateMutability": "nonpayable",
          "type": "constructor"
        },
        {
          "anonymous": false,
          "inputs": [
            {
              "indexed": false,
              "internalType": "uint8",
              "name": "version",
              "type": "uint8"
            }
          ],
          "name": "Initialized",
          "type": "event"
        },
        {
          "inputs": [],
          "name": "activePool",
          "outputs": [
            {
              "internalType": "contract IActivePool",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "calculateAllDebtPerCollateral",
          "outputs": [
            {
              "internalType": "address[]",
              "name": "collaterals",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "debts",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "startVaultIndex",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "endVaultIndex",
              "type": "uint256"
            }
          ],
          "name": "calculateDebtPerCollateralPerVaultRange",
          "outputs": [
            {
              "internalType": "address[]",
              "name": "collaterals",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "debts",
              "type": "uint256[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "baseDebt",
              "type": "uint256"
            },
            {
              "internalType": "address",
              "name": "collateral",
              "type": "address"
            },
            {
              "internalType": "uint256",
              "name": "collateralAmount",
              "type": "uint256"
            }
          ],
          "name": "calculateTotalDebt",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "totalDebt",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "borrowingFee",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "variableFee",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "controller",
          "outputs": [
            {
              "internalType": "contract IVaultedgeController",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "debtCapManager",
          "outputs": [
            {
              "internalType": "contract IDebtCapManager",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getAllCollateralDebtCapStatuses",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address",
                  "name": "collateral",
                  "type": "address"
                },
                {
                  "internalType": "uint256",
                  "name": "debtCap",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "currentDebtOnManager",
                  "type": "uint256"
                },
                {
                  "internalType": "uint256",
                  "name": "currentDebtActual",
                  "type": "uint256"
                }
              ],
              "internalType": "struct DebtCapLens.CollateralDebtCapStatus[]",
              "name": "statuses",
              "type": "tuple[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getSystemState",
          "outputs": [
            {
              "components": [
                {
                  "internalType": "address[]",
                  "name": "validCollateral",
                  "type": "address[]"
                },
                {
                  "internalType": "uint256",
                  "name": "totalVaults",
                  "type": "uint256"
                },
                {
                  "internalType": "address[]",
                  "name": "collaterals",
                  "type": "address[]"
                },
                {
                  "internalType": "uint256[]",
                  "name": "debts",
                  "type": "uint256[]"
                }
              ],
              "internalType": "struct DebtCapLens.SystemState",
              "name": "state",
              "type": "tuple"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getValidCollateral",
          "outputs": [
            {
              "internalType": "address[]",
              "name": "validCollaterals",
              "type": "address[]"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "uint256",
              "name": "index",
              "type": "uint256"
            }
          ],
          "name": "getVaultFromVaultOwnersArray",
          "outputs": [
            {
              "internalType": "address",
              "name": "owner",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "getVaultOwnersCount",
          "outputs": [
            {
              "internalType": "uint256",
              "name": "totalVaults",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "vault",
              "type": "address"
            }
          ],
          "name": "getVaultState",
          "outputs": [
            {
              "internalType": "address[]",
              "name": "tokens",
              "type": "address[]"
            },
            {
              "internalType": "uint256[]",
              "name": "amounts",
              "type": "uint256[]"
            },
            {
              "internalType": "uint256",
              "name": "debt",
              "type": "uint256"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        },
        {
          "inputs": [
            {
              "internalType": "address",
              "name": "_vaultManager",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_controller",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_activePool",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "_debtCapManager",
              "type": "address"
            }
          ],
          "name": "initialize",
          "outputs": [],
          "stateMutability": "nonpayable",
          "type": "function"
        },
        {
          "inputs": [],
          "name": "vaultManager",
          "outputs": [
            {
              "internalType": "contract IVaultManager",
              "name": "",
              "type": "address"
            }
          ],
          "stateMutability": "view",
          "type": "function"
        }
      ],
      "inheritedFunctions": {}
    }
  },
  "59141": {}
} as const satisfies GenericContractsDeclaration

// Type-safe helper functions for Scaffold-ETH integration
export function getContractsForChain(chainId: SupportedChainId): Record<string, GenericContract> | undefined {
  return (deployedContracts as any)[chainId]
}

export function getAllSupportedChains(): SupportedChainId[] {
  return Object.keys(deployedContracts).map(Number) as SupportedChainId[]
}

export function getContractAbi(chainId: SupportedChainId, contractName: ContractName): any[] | undefined {
  return (deployedContracts as any)[chainId]?.[contractName]?.abi
}

export function getContractAddress(chainId: SupportedChainId, contractName: ContractName): string | undefined {
  return (deployedContracts as any)[chainId]?.[contractName]?.address
}

// Type guard to check if a chain ID is supported
export function isSupportedChainId(chainId: number): chainId is SupportedChainId {
  return [57054, 59141].includes(chainId)
}

// Type guard to check if a contract name is valid
export function isValidContractName(contractName: string): contractName is ContractName {
  return ["ActivePool", "BorrowerOperations", "CollSurplusPool", "DebtCapLens", "DebtCapManager", "DefaultPool", "HintHelpers", "SortedVaults", "StabilityPool", "VaultManager", "VaultedgeController", "VeUSDToken"].includes(contractName as ContractName)
}
